<template lang="html">

	<section class="banner-promociones column-start animation">

		<div class="container column-start animation">

			<h2 class="column-center">
				<span class="s">{{$t('acercate')}}</span>
				<span class="m">{{$t('vernuestras')}}</span>
				<span class="l">{{$t('promociones')}}</span>
			</h2>

			<router-link :to="$t('enlaces.promociones')" class="btn -action">{{$t('todas')}}<span>{{$t('lasPromos')}}</span></router-link>

			<img src="/static/img/abanico-promociones.png" class="abanico-promociones" alt="">

		</div>


		<img src="/static/img/chica-promociones.png" class="chica-promociones">



	</section>

</template>

<script lang="js">



	export default  {
		name: 'banner-promociones',
	}
</script>

<style scoped lang="scss">
	.banner-promociones {
		width: 100%;
		background-image: linear-gradient(to top, #fcb734, #e69a01);
		position: relative;
		overflow: hidden;
		padding: 100px 100px;
		padding-bottom: 0;
		justify-content: flex-start;
		-webkit-justify-content: flex-start;
	}
	
	.chica-promociones{
		position: absolute;
		right: 0;
		bottom: -20px;
		display: inline-block;
		max-height: 100%;
		transform:  perspective(100px) translateZ(-100px) translate(0,1200px);
	}

	.launched .chica-promociones{
		animation-name: animacionChica;
		animation-duration: .8s;
		animation-delay: 4s;
		animation-fill-mode: forwards;
		animation-timing-function: cubic-bezier(.4,.77,.23,1.2);
	}

	@keyframes animacionChica{
		to{
			transform: translateY(0%);
		}
	}

	.abanico-promociones{
		position: absolute;
		left:-100px;
		bottom: -50px;
		max-width: 800px;
		opacity: 0;
		transition: 1s;
		transform: translateY(900px) scale(.5);
		transition-delay: 1s;;
	}

	.launched .abanico-promociones{
		opacity: 1;
		transform:none;
	}


	.container{
		position: relative;
		height: 100%;
		min-height: 650px;
		justify-content: space-between;
		-webkit-justify-content: space-between;
		padding-bottom: 100px;
	}

	h2{
		width: 100%;
		max-width: 700px;
		position: relative;
		z-index: 3;
		overflow: hidden;
		padding-top: 40px;
		margin-top: -40px;

		span{
			font-family: 'Futura LT CondensedExtraBold';
			text-transform: uppercase;
			transform: translateY(300px) perspective(100px) translateZ(-50px);
		}

		.s{
			font-size: 60px;
			text-align: left;
			line-height: .9em;
			color: rgba(255,255,255,.5);
			display: inline-block;
			width: 100%;
			animation-delay: .5s;
		}

		.m{
			font-size: 80px;
			text-align: center;
			line-height: .9em;
			color: rgba(255,255,255,1);
			display: inline-block;
			width: 100%;
			animation-delay: 1.3s;

		}

		.l{
			font-size: 100px;
			text-align: left;
			line-height: .9em;
			color: rgba(127, 88, 0,.2);
			display: inline-block;
			width: 100%;
			animation-delay: 2.2s;
		}
	}

	.launched h2 span{
		animation-duration: 1.4s;
		-webkit-animation-fill-mode: forwards;
		-o-animation-fill-mode: forwards;
		animation-fill-mode: forwards;
		animation-timing-function: cubic-bezier(.4,.77,.23,1.2);
		animation-name: allReset;
	}

	.btn{
		display: -webkit-flex;
		display: -moz-flex;
		display: -ms-flex;
		display: -o-flex;
		display: flex;
		-webkit-flex-direction: column;
		-moz-flex-direction: column;
		-ms-flex-direction: column;
		-o-flex-direction: column;
		flex-direction: column;
		font-size: 56px;
		line-height: 60px;
		position: relative;
		color: #f8b425;
		align-self: flex-end;
		transform: translateY(400px) perspective(100px) translateZ(60px);
		z-index: 4;
		height: 80px;

		span{
			font-family: 'Futura LT CondensedExtraBold';
			font-size: 18px;
			line-height:21px;
			position: absolute;
			width: 100%;
			bottom: 2px;
			text-align: center;
			left: 4px;
			color: #f8b425;
		}
	}

	.launched .btn{
		animation-duration: 1s;
		-webkit-animation-fill-mode: forwards;
		-o-animation-fill-mode: forwards;
		animation-fill-mode: forwards;
		animation-timing-function: cubic-bezier(.4,.77,.23,1.2);
		animation-name: allReset;
		animation-delay: 5s;
	}

	.banner-promociones .abanico{
		position: absolute;
		left: 0;
		bottom: -30px;
		z-index: 4;
	}

	@media screen and (max-width: 1330px){
		.abanico-promociones{
			max-width: 600px;
			bottom: 50px;
		}
	}

	@media screen and (max-width: 1130px){

		.container{
			justify-content: flex-start;
			-webkit-justify-content: flex-start;
		}

		.btn{
			align-self: unset;
			margin-top: 30px;
			position: relative;
			z-index: 5;
		}
		.abanico-promociones{
			display: none;
		}
	}

	@media screen and (max-width: 950px){
		.banner-promociones{
			padding: 50px;

			.abanico{
				left: 150px;
				bottom: -70px;
				transform: scale(1.6);
			}
		}

		.chica-promociones{
			bottom: -50px;
			right: -200px;
		}

				.btn{
			transform: translateY(590px) perspective(100px) translateZ(60px);
		}
	}

	@media screen and (max-width: 800px){
		.container{
			min-height: 450px;
		}

		h2{
			.s{
				font-size: 30px;
			}

			.m{
				font-size: 40px;
				text-align: left;
				padding-left: 50px;
			}

			.l{
				font-size: 60px;
			}
		}



	}

	@media screen and (max-width: 600px){

		.banner-promociones{

			padding: 50px 0;

			.container{
				min-height: 350px;
			}

			.abanico{
				left: 70px;
				bottom: -90px;
				transform: scale(1.3);
			}

		}
	}

	@media screen and (max-width: 450px){

		.banner-promociones{

			padding: 50px 0;

			.container{
				min-height: 350px;
			}

			.abanico{
				left: 20px;
				bottom: -90px;
				transform: scale(1);
			}

			h2{
				.s{
					font-size: 20px;
				}

				.m{
					font-size: 30px;
					text-align: left;
					padding-left: 50px;
				}

				.l{
					font-size: 40px;
				}
			}

			.btn{
				font-size: 45px;

				span{
					font-size: 16px;
				}
			}

		}
	}

</style>



// WEBPACK FOOTER //
// src/components/parts/banner-promociones.vue